import React, { memo } from 'react';

import locale from 'antd/es/date-picker/locale/ru_RU';

import { TimePicker } from 'antd';

const Picker = props => <TimePicker style={{ width: '100%' }} size="large" locale={locale} {...props} />;

export default memo(Picker);
